import { render, staticRenderFns } from "./PostFields.vue?vue&type=template&id=6108b248"
import script from "./PostFields.vue?vue&type=script&lang=js"
export * from "./PostFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports